import i18n from 'i18next';
import { superAxios } from '../../../shared/utils/axios';
import { addToast } from '../toasts/toastsActions';
import { toastTypes } from '../../../shared/components/Toast/ToastOptions';
import { actionSuccess } from '../utils';

export const FETCH_PAYMENTS = 'FETCH_PAYMENTS';
export const EDIT_PAYMENTS = 'EDIT_PAYMENTS';

const fetchPaymentsEndpoint = `${process.env.REACT_APP_API_URL}super/payments`;
const putPaymentEndpoint = paymentId => `${process.env.REACT_APP_API_URL}super/payment/${paymentId}`;
const putCancelTransactionEndpoint = identifier =>
  `${process.env.REACT_APP_API_URL}super/payment/${identifier}/cancel-transaction`;

export const fetchPayments = () => async dispatch => {
  try {
    const response = await superAxios.get(fetchPaymentsEndpoint);
    dispatch(actionSuccess(FETCH_PAYMENTS, response?.data?.data));

    return response.data;
  } catch (error) {
    dispatch(addToast(toastTypes.error, error));
  }
};

export const editPayment = (payment, status) => async dispatch => {
  try {
    const response = await superAxios.put(putPaymentEndpoint(payment?.identifier), { status });
    dispatch(actionSuccess(EDIT_PAYMENTS, response?.data?.data));

    dispatch(
      addToast({
        ...toastTypes.success,
        defaultMessage: i18n.t('payment.put.success', { ns: ['actions'] })
      })
    );
  } catch (error) {
    dispatch(
      addToast(
        {
          ...toastTypes.error,
          defaultMessage: i18n.t('payment.put.error', { ns: ['actions'] })
        },
        error
      )
    );
  }
};

export const cancelTransaction = (identifier, reason) => async dispatch => {
  try {
    const response = await superAxios.put(putCancelTransactionEndpoint(identifier), { reason });
    dispatch(actionSuccess(EDIT_PAYMENTS, response?.data?.data));

    if (response?.status === 202) {
      dispatch(
        addToast({
          ...toastTypes.success,
          defaultMessage: response?.data?.message
        })
      );
      return true;
    }

    dispatch(
      addToast({
        ...toastTypes.success,
        defaultMessage: `${i18n.t('payment.cancel.put', {
          ns: ['actions']
        })} ${response?.data?.message}`
      })
    );

    return true;
  } catch (error) {
    dispatch(
      addToast(
        {
          ...toastTypes.error,
          defaultMessage: i18n.t('payment.cancel.error', {
            ns: ['actions']
          })
        },
        error
      )
    );
    return false;
  }
};
